export const iconFontAwesomeHumanitarianPlugCirclePlus = (
	<i className="fa-solid fa-plug-circle-plus"></i>
);
